import React from 'react';
import styles from './CardUser.module.css';
import logoUsuarios from '../../Assets/logoUsuarios.png'

// Función para calcular días restantes hasta el vencimiento
function diasRestantes(fechaVencimiento) {
  const hoy = new Date();
  const vencimiento = new Date(fechaVencimiento);
  const diff = vencimiento - hoy;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

// Formatea el teléfono como +54 11 1234-5678 o similar
function formatoTelefono(numero) {
  if (!numero) return '';
  // Elimina caracteres no numéricos
  const limpio = numero.replace(/\D/g, '');
  if (limpio.length === 10) {
    // Ejemplo: 1122334455 => (11) 2233-4455
    return `(${limpio.slice(0,2)}) ${limpio.slice(2,6)}-${limpio.slice(6)}`;
  }
  if (limpio.length === 11) {
    // Ejemplo: 91122334455 => (911) 2233-4455
    return `(${limpio.slice(0,3)}) ${limpio.slice(3,7)}-${limpio.slice(7)}`;
  }
  return numero;
}

const CardUser = ({ user }) => {
  const dias = diasRestantes(user.cuota_vencimiento);
  return (
      <a href={`/edit-user/${user.id}`} className={styles.cardLink}>
      <div className={styles.row}>
        <div className={styles.cell}>
          <img
            src={user.photo && user.photo.trim() !== '' ? user.photo : logoUsuarios}
            alt={user.name}
            className={styles.photo}
            onError={e => { e.target.onerror = null; e.target.src = logoUsuarios; }}
          />
        </div>
        <div className={styles.cell}>{user.name} {user.last_name}</div>
        <div className={styles.cell}>{user.dni}</div>
        <div className={styles.cell}>{user.email}</div>
        <div className={styles.cell}>
          <a href={`tel:${user.phone_number}`} onClick={e => e.stopPropagation()}>
            {formatoTelefono(user.phone_number)}
          </a>
        </div>
        <div className={styles.cell}>
          <span style={{ color: user.cuotaPaga ? 'green' : 'red', fontWeight: 'bold' }}>
            {user.cuotaPaga ? 'Sí' : 'No'}
          </span>
        </div>
        <div className={styles.cell}>
          {user.cuota_vencimiento}
          <span style={{ marginLeft: 8, color: dias <= 5 ? 'red' : 'inherit' }}>
            {dias > 0 ? `Faltan ${dias} días` : dias === 0 ? 'Vence hoy' : 'Vencido'}
          </span>
        </div>
      </div>
    </a>
  );
};

export default CardUser;